export function postMsg(type, data?, callBack?) {
  try {
    let params = { type, data };
    window.postMessage(JSON.stringify(params), "*");
    console.log("已向RN发送数据", params);
    callBack && callBack();
  } catch (e) {
    console.log("postError", e, type, data);
  }
}
